$( document ).ready(function() {
  
  $(document).on('click', '.site-header__cart', openMiniCart);
  
  createMiniCart();

  
});

function openMiniCart() {
  event.preventDefault();
  
  var miniCart = $('.js-mini-cart');
  if ( miniCart.hasClass('is-active') ) {
  	miniCart.removeClass('is-active');
  } else {
  	miniCart.addClass('is-active');
  }

}

function createMiniCart() {

  var cartProducts = [];

  
  jQuery.getJSON('/cart.js', function(cart) {
    var products = cart.items;
    $.each(products, function(key, product) {
      var item = [];
      item['image'] = product.featured_image.url;
      item['title'] = product.product_title;
      item['variant'] = product.variant_options[0];
      item['price'] = product.price/100;
      item['quantity'] = product.quantity;
      cartProducts.push(item);
    });
    
    var miniCart = $('.c-minicart__items');
    
    var html = [];
    
    var total = 0;
    
    var quantity = 0;
    
    if (cartProducts.length > 0) {
    
      $.each(cartProducts, function (key, item) {
        var total_price = (item.price * item.quantity).toFixed(2);

        total += parseFloat(total_price);
        
        quantity += item.quantity;


        html.push('<div class="c-minicart__item">');
        html.push('<div class="l-row l-row--gap-tiny">');
        html.push('<div class="l-col l-col-15">');
        html.push('<img class="c-minicart__item-img" src="' + item.image + '" alt="" width="180" height="180" />');
        html.push('</div>');
        html.push('<div class="l-col l-col-30">');
        html.push('<div class="c-minicart__item-title">' + item.title + '</div>');
        html.push('<div class="c-minicart__item-variant-title light-text small-text">' + item.variant + '</div>');
        html.push('<div class="c-minicart__item-quantity small-text">' + item.quantity + ' Stück </div>');
        html.push('</div>');
        html.push('<div class="l-col l-col-15 text-right">');
        html.push('€&nbsp;' + total_price);
        html.push('</div>');
        html.push('</div>');
        html.push('</div>');
      });

      html.push('<div class="c-minicart__totals">');
      html.push('<div>');
      html.push('<div class="c-minicart__totals-title">Gesamtsumme</div>');
      html.push('<div class="c-minicart__totals-tax light-text small-text">inkl. MwSt.</div>');
      html.push('</div>');
      html.push('€&nbsp;' + total.toFixed(2));
      html.push('</div>');
      $('.c-minicart__no-items').addClass('is-hidden');
      
      

    } else {
      html.push('<div class="c-minicart__no-items">Keine Artikel im Warenkorb</div>');
    }
    
    miniCart.append(html.join(''));  
    
    $('.site-header__cart-count span').text(quantity);
    
  });

}



